var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14.8334C8.60237 14.8334 12.3333 11.1025 12.3333 6.50008C12.3333 5.03571 11.9556 3.65955 11.2923 2.46373C13.7238 1.31138 16.4429 0.666748 19.3124 0.666748C29.6677 0.666748 38.0624 9.06138 38.0624 19.4167C38.0624 29.772 29.6677 38.1666 19.3124 38.1666C8.95713 38.1666 0.5625 29.772 0.5625 19.4167C0.5625 17.6678 0.801928 15.9749 1.24979 14.3689C2.11082 14.6698 3.03631 14.8334 4 14.8334Z",
    fill: "#FF9900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9723_28911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0624 19.4167C38.0624 29.772 29.6677 38.1666 19.3124 38.1666C8.95713 38.1666 0.5625 29.772 0.5625 19.4167C0.5625 9.06138 8.95713 0.666748 19.3124 0.666748C29.6677 0.666748 38.0624 9.06138 38.0624 19.4167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0624 19.4167C38.0624 29.772 29.6677 38.1666 19.3124 38.1666C8.95713 38.1666 0.5625 29.772 0.5625 19.4167C0.5625 9.06138 8.95713 0.666748 19.3124 0.666748C29.6677 0.666748 38.0624 9.06138 38.0624 19.4167Z",
    stroke: "#967100"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9723_28911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6366 9.8335L40.6666 26.2476L23.2624 43.1668L12.3333 32.651L20.0997 23.6863L23.6366 9.8335Z",
    fill: "#7D4B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6601 25.684L20.9414 25.3696V23.1462H16.4498V25.3696L15.7537 25.6615L15.9333 31.9721H16.4498V32.9603H20.9414V31.9721H21.4579L21.6601 25.684Z",
    fill: "#F2AE75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.941 23.3706V25.1897L16.4495 24.471V23.3706H20.941Z",
    fill: "#E3B9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0605 36.1267C29.6563 33.2746 29.252 31.2534 28.2639 29.0749C27.433 27.2783 25.1198 26.8292 21.8185 25.7063C21.7062 25.6614 21.5715 25.6164 21.4592 25.5715V25.594C21.2346 26.8292 20.6282 28.4237 18.6969 28.6033C16.788 28.4237 16.1592 26.8292 15.9346 25.594V25.5715C15.8223 25.6164 15.6875 25.6614 15.5753 25.7063C12.2515 26.8516 9.96081 27.2783 9.12987 29.0749C8.14173 31.2309 7.73749 33.2746 7.33325 36.1267L18.7193 39.9445L30.0605 36.1267Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7741 28.1993L19.3474 29.0303H18.0449L17.6182 28.1993L18.6961 27.3235L19.7741 28.1993Z",
    fill: "#0C6A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6967 27.3234L17.3043 28.7832L14.6094 26.0209L16.406 25.2349L16.9674 25.7514L18.6967 27.3234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6965 27.3234L20.0889 28.7832L22.7839 26.0209L20.9872 25.2349L20.4258 25.7514L18.6965 27.3234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5723 39.72L19.3477 29.2322H18.0451L17.8206 39.72H19.5723Z",
    fill: "#0C6A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5693 16.813L23.7265 14.8367C23.7265 12.2541 21.2562 10.1655 18.6735 10.1655C16.0909 10.1655 13.6205 12.2541 13.6205 14.8367L13.7777 16.813C13.643 16.8579 13.5082 16.9253 13.3959 17.0151C13.1938 17.1948 13.0591 17.4418 13.0591 17.7338V18.6995C13.0591 19.216 13.4633 19.6202 13.9798 19.6427C13.9798 22.0906 16.9218 24.4038 18.6735 24.4038C20.4252 24.4038 23.3672 22.0906 23.3672 19.6427C23.8837 19.6427 24.288 19.216 24.288 18.6995V17.7338C24.288 17.2846 23.9736 16.9029 23.5693 16.813Z",
    fill: "#F2AE75"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.569 16.813L23.7262 14.8367C23.7262 12.2541 21.2558 10.1655 18.6732 10.1655V16.813C17.9994 18.2728 17.5503 20.3614 17.5503 20.3614H18.6732V24.3813C20.4249 24.3813 23.3669 22.0681 23.3669 19.6202C23.8834 19.6202 24.2876 19.1936 24.2876 18.677V17.7113C24.2876 17.2846 23.9732 16.9029 23.569 16.813Z",
    fill: "#F6CCB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.019 16.813C23.8618 17.4643 23.6597 17.7338 23.4127 18.385L23.3902 16.566L22.3347 13.377C22.3347 13.377 20.6728 13.7363 18.719 13.8261C16.7652 13.7363 15.1033 13.377 15.1033 13.377L14.0478 16.566V18.385C13.9355 18.0706 13.5313 17.1499 13.4414 16.813C12.9698 14.7693 12.9923 12.7481 13.6436 11.1761C13.6436 11.1761 14.7889 8.16675 18.719 8.16675C18.8089 8.16675 18.8762 8.16675 18.9661 8.16675C20.0216 8.16675 20.7851 8.36887 21.5038 8.72819C21.5038 8.72819 22.6716 9.28964 23.6597 8.84048C23.6822 8.81802 23.7271 8.84048 23.7271 8.8854C23.7046 9.02015 23.6597 9.28964 23.4576 9.53667C23.7046 9.53667 23.9966 9.53667 24.3335 9.44684V9.4693C24.3559 10.1206 24.1313 10.7045 23.8169 11.1985C24.4682 12.7706 24.4907 14.7693 24.019 16.813Z",
    fill: "#4F3C30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAdminIcon);
export default __webpack_public_path__ + "static/media/CompanyAdminIcon.608d3cc87a2698a921206a6cc970ee14.svg";
export { ForwardRef as ReactComponent };